// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../atoms/Icon/Icon__Jsx3.bs.js");
var TailwindMerge = require("tailwind-merge");
var TailwindVariants = require("../../../../v5/bindings/TailwindVariants.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var TailwindVariants$1 = require("tailwind-variants");
var Theme__Color__Vars = require("../../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var ReactAriaComponents = require("react-aria-components");

var overlayStyles = TailwindVariants$1.tv({
      base: "fixed top-0 left-0 w-full h-full isolate z-20 bg-[#1b3549]/50 flex items-start justify-center px-4 pt-20 pb-10 sm:pt-24 sm:pb-16 backdrop-blur-sm overscroll-contain overflow-y-auto",
      variants: {
        isEntering: {
          true: "animate-in fade-in duration-200 ease-out"
        },
        isExiting: {
          true: "animate-out fade-out duration-200 ease-in"
        }
      }
    });

var modalStyles = TailwindVariants$1.tv({
      base: "w-full rounded-md bg-white forced-colors:bg-[Canvas] text-left align-middle text-slate-700 shadow-md bg-clip-padding",
      variants: {
        isEntering: {
          true: "animate-in zoom-in-105 ease-out duration-200"
        },
        isExiting: {
          true: "animate-out zoom-out-95 ease-in duration-200"
        },
        size: {
          Small: "max-w-[320px] sm:max-w-[340px]",
          Default: "max-w-[400px]",
          Large: "max-w-[500px]",
          XLarge: "max-w-[600px]",
          XXLarge: "max-w-[680px]",
          LgWide: "sm:max-w-[560px] md:max-w-[580px]",
          XlWide: "sm:max-w-[600px] md:max-w-[700px]"
        }
      }
    });

var Styles = {
  overlayStyles: overlayStyles,
  modalStyles: modalStyles
};

function closeButtonClassName(v) {
  return TailwindMerge.twMerge([
              "fixed top-0 right-0 p-[20px] cursor-pointer focus:outline-none rounded",
              TailwindVariants.Utils.focusRing({
                    isFocusVisible: v.isFocusVisible
                  })
            ]);
}

function DialogV5$TitleSection(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("h2", {
                    children: props.children,
                    className: "text-white text-4xl font-light"
                  }),
              className: "flex flex-col justify-center content-center w-full mb-2 p-4 text-center bg-tan-blue-500 sm:rounded-t-md"
            });
}

var TitleSection = {
  make: DialogV5$TitleSection
};

function DialogV5$UnstyledContent(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "flex flex-col p-4"
            });
}

var UnstyledContent = {
  make: DialogV5$UnstyledContent
};

function DialogV5$Content(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "box-border flex flex-col justify-center content-center w-full sm:rounded-md"
            });
}

var Content = {
  make: DialogV5$Content
};

function DialogV5(props) {
  var children = props.children;
  var __showCloseButton = props.showCloseButton;
  var __size = props.size;
  var __customContent = props.customContent;
  var onDismiss = props.onDismiss;
  var title = props.title;
  var customContent = __customContent !== undefined ? __customContent : false;
  var size = __size !== undefined ? __size : "Default";
  var showCloseButton = __showCloseButton !== undefined ? __showCloseButton : true;
  return JsxRuntime.jsxs(ReactAriaComponents.ModalOverlay, {
              children: [
                showCloseButton ? JsxRuntime.jsx(ReactAriaComponents.Button, {
                        children: JsxRuntime.jsx(Icon__Jsx3.make, {
                              icon: "Cancel",
                              size: 24,
                              color: Theme__Color__Vars.white
                            }),
                        slot: "close",
                        className: (function (v) {
                            return closeButtonClassName(v);
                          }),
                        onClick: (function (param) {
                            onDismiss();
                          })
                      }) : null,
                JsxRuntime.jsx(ReactAriaComponents.Modal, {
                      children: JsxRuntime.jsx(ReactAriaComponents.Dialog, {
                            children: customContent ? JsxRuntime.jsx(DialogV5$Content, {
                                    children: children
                                  }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                    children: [
                                      title !== undefined ? JsxRuntime.jsx(ReactAriaComponents.Heading, {
                                              children: JsxRuntime.jsx(DialogV5$TitleSection, {
                                                    children: title
                                                  }),
                                              slot: "title"
                                            }) : null,
                                      JsxRuntime.jsx(DialogV5$UnstyledContent, {
                                            children: children
                                          })
                                    ]
                                  }),
                            ariaLabel: props.ariaLabel
                          }),
                      className: (function (v) {
                          return modalStyles({
                                      isEntering: v.isEntering,
                                      isExiting: v.isExiting,
                                      state: v.state,
                                      size: size
                                    });
                        }),
                      isDismissable: true
                    })
              ],
              isDismissable: true,
              className: (function (v) {
                  return overlayStyles({
                              isEntering: v.isEntering,
                              isExiting: v.isExiting,
                              state: v.state,
                              size: size
                            });
                }),
              isOpen: props.isOpen,
              onOpenChange: (function (newOpen) {
                  if (!newOpen) {
                    return onDismiss();
                  }
                  
                })
            });
}

var make = DialogV5;

var dialog = DialogV5;

exports.Styles = Styles;
exports.closeButtonClassName = closeButtonClassName;
exports.TitleSection = TitleSection;
exports.UnstyledContent = UnstyledContent;
exports.Content = Content;
exports.make = make;
exports.dialog = dialog;
/* overlayStyles Not a pure module */
